var _polygon, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "red",
    points: "24,3 28.3,7.8 34.5,5.8 35.9,12.1 42.2,13.5 40.2,19.7 45,24 40.2,28.3 42.2,34.5 35.9,35.9  34.5,42.2 28.3,40.2 24,45 19.7,40.2 13.5,42.2 12.1,35.9 5.8,34.5 7.8,28.3 3,24 7.8,19.7 5.8,13.5 12.1,12.1 13.5,5.8 19.7,7.8  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "20,32.3 18.3,31.3 28,15.7 29.7,16.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19,14c-1.8,0-4,1.1-4,4v1c0,1.8,1.1,4,4,4c2.1,0,4-1.4,4-4v-1C23,15.5,21.3,14,19,14z M20.8,19 c0,1.3-0.7,2-1.8,2c-0.9,0-1.8-0.6-1.8-2v-1c0-1.4,0.9-2.1,1.8-2.1c1.4,0,1.8,1.3,1.8,2.1V19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29,34c1.8,0,4-1.1,4-4v-1c0-1.8-1.1-4-4-4c-2.1,0-4,1.4-4,4v1C25,32.5,26.7,34,29,34z M27.2,29 c0-1.3,0.7-2,1.8-2c0.9,0,1.8,0.6,1.8,2v1c0,1.4-0.9,2.1-1.8,2.1c-1.4,0-1.8-1.3-1.8-2.1V29z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.382c852e4af13f80a58dd941d1b70ffc.svg";
export { ForwardRef as ReactComponent };